// Original hypothetical data. Each question fixes the population, period or rate convention.
export const marketsReview = {
  moduleId: 'markets',
  title: '經濟數字變動，先確認它在量什麼',
  questions: [
    {
      id: 'markets-slower-inflation-price-level',
      lessonId: 'cpi-inflation',
      question: '同一基期、同口徑的假想 CPI，連續三年 12 月依序為 100、106、109.18。後兩年的 12 月年增率從 6% 降到 3%，應怎麼解讀？',
      options: [
        '最後一年平均物價比前一年下跌 3%',
        '通膨減半，所以最後一年的物價水準已回到 100',
        '漲價速度放慢，但最後一年物價仍比前一年高 3%，比兩年前高 9.18%',
      ],
      answer: 2,
      explanation: '最後一年年增率＝109.18 ÷ 106−1＝3%；相對兩年前則是 109.18 ÷ 100−1＝9.18%。通膨率下降與物價水準下降是不同的事。這是整體指數的比較，不能推論每一項商品都漲同樣幅度，也不能單憑年增率判斷當月相較上月的變化。',
    },
    {
      id: 'markets-pmi-below-neutral',
      lessonId: 'pmi-cycle',
      question: '某國同口徑、以 50 為榮枯分界的製造業 PMI，從上月 48 升到本月 49。只依這兩筆假想數據，哪個解讀合理？',
      options: [
        '仍在 50 以下，製造業調查訊號偏向較前月收縮，但比上月接近持平',
        '指數增加 1 點，所以製造業實際產量成長 1%',
        '只要 PMI 比上月高，整個國家的 GDP 就已經轉為成長',
      ],
      answer: 0,
      explanation: 'PMI 是反映受訪企業相較前月變化的擴散指數，50 是持平分界，並非成長率的 0%。49 仍低於 50；從 48 升到 49，不能直接換算為實際產量增加 1%，也不能只靠製造業這一項調查替整體 GDP 下結論。',
    },
    {
      id: 'markets-labor-force-denominator',
      lessonId: 'labor-market',
      question: '假想統計涵蓋人口固定 2,000 人：就業 1,140 人、失業 60 人。下期有 60 名原非勞動力開始參與，其中 30 人找到工作，另 30 人符合失業定義，其他分類不變。哪個敘述正確？',
      options: [
        '失業率為 4.5%，因為分母應使用全部 2,000 人',
        '就業增加 30 人，失業率仍升至約 7.14%，勞參率升至 63%',
        '只要就業增加，失業率就必定下降',
      ],
      answer: 1,
      explanation: '原勞動力為 1,140＋60＝1,200 人，失業率為 5%，勞參率為 60%。下期就業 1,170 人、失業 90 人，勞動力共 1,260 人，失業率為 90 ÷ 1,260≈7.14%，勞參率為 1,260 ÷ 2,000＝63%。更多人進入求職市場時，就業增加與失業率上升可以同時發生；實際資料仍須核對分類規則。',
    },
    {
      id: 'markets-reference-period-and-revision',
      lessonId: 'economic-releases',
      question: '一份假想發布表寫著：4 月 30 日公布「第一季實質 GDP 季增年率初估 2.4%」；5 月 30 日公布「同一季、同一季調口徑修正為 1.9%」。應如何讀這兩次發布？',
      options: [
        '5 月經濟比 4 月成長 1.9%',
        '第一季已成長 2.4%，5 月又替第一季額外創造 1.9% 的產出',
        '兩次都描述第一季，估計值下修 0.5 個百分點；發布月份不是資料所屬期',
      ],
      answer: 2,
      explanation: '2.4% 與 1.9% 是同一季度、同一比較口徑的不同版本，估計值下修 0.5 個百分點，修正後仍為正成長。資料補齊或更新不代表發布日又產生一次成長。季增年率也不是單季直接成長 1.9%；閱讀時保留所屬期、發布日期、季調與年化方式，以及當時可取得的版本，後續仍可能再修正。',
    },
  ],
};
